import { createSelector } from 'reselect'

export const profileAdditionalStoreSelector = (s) => s.profileAdditional

export const profileAdditionalSelector = createSelector(
  profileAdditionalStoreSelector,
  (s) => s.profileAdditional || {}
)
